module.exports = __webpack_public_path__ + "img/4-1.bfbd8e1a.svg";